<template>
  <h4 class="title">Dados do inscrito</h4>

  <div class="scroll-table">
    <table id="data-table" class="table">
      <tbody>
        <tr v-if="loadingUserData">
          <td class="text-center" colspan="4" style="border-radius: 10px">
            <div class="loading">
              <div class="spinner-border text-light" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <span> Carregando dados... </span>
            </div>
          </td>
        </tr>
        <tr v-for="field in fields" v-else :key="field">
          <td>
            <span>{{ field.campo }}</span>
          </td>
          <td>
            <span>{{ field.dado }}</span>
          </td>
          <td>
            <div
              v-if="field.dado && field.dado !== 'Não selecionado'"
              class="inconsistent-box"
            >
              <label id="label-checkbox">
                <input
                  v-model="checkField"
                  :value="field"
                  type="checkbox"
                  @change="check(field.nome)"
                />
                <span id="text" for="checkbox-input">Inconsistente</span>
              </label>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <h4 class="title">Arquivos do inscrito</h4>

  <div class="scroll-table">
    <table id="file-table" class="table">
      <tbody>
        <tr v-if="loadingUserData">
          <td class="text-center" colspan="4" style="border-radius: 10px">
            <div class="loading">
              <div class="spinner-border text-light" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <span> Carregando dados... </span>
            </div>
          </td>
        </tr>
        <tr v-for="file in files" v-else :key="file">
          <td>
            <a :href="file.href" target="_blank">
              <button :disabled="file.href === '#'" class="view">
                <img alt="Visualizar" src="../../assets/svg/lupa_action.svg" />
              </button>
            </a>
            <span>{{ file.documento }}</span>
          </td>
          <td>
            <div v-if="file.href !== '#'" class="inconsistent-box">
              <label id="label-checkbox">
                <input v-model="checkFile" :value="file" type="checkbox" />
                <span id="text" for="checkbox-input">Inconsistente</span>
              </label>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="buttons">
    <button
      :disabled="
        (checkField.length === 0 && checkFile.length === 0) ||
        loadingUserData === true
      "
      @click="revision"
    >
      Pedir revisão
    </button>
    <button
      :disabled="
        checkField.length !== 0 ||
        checkFile.length !== 0 ||
        loadingUserData === true
      "
      class="btn-to-approve"
      @click="sendValidation"
    >
      Aprovar
    </button>
  </div>

  <RevisionModal :fields="checkField" :files="checkFile" />
  <ReviewSentModal />
  <LoadingScreen :show="loadingScreen" />
</template>

<script>
import { Supervisor, UserService } from "../../services";
import RevisionModal from "./RevisionModal.vue";
import ReviewSentModal from "./ReviewSentModal.vue";
import { Modal } from "bootstrap";
import LoadingScreen from "../LoadingScreen.vue";

export default {
  components: {
    RevisionModal,
    ReviewSentModal,
    LoadingScreen,
  },

  name: "EvaluateEnrolled",
  data() {
    return {
      loadingUserData: false,
      loadingScreen: false,
      student: null,

      revisionModal: null,
      reviewSentModal: null,

      checkField: [],
      checkFile: [],

      fields: [],

      files: [
        {
          documento: "Documento: Carteira de identidade",
          nome: "doc_identidade",
          tipo: 1,
          href: "#",
        },
        {
          documento: "Documento: CPF",
          tipo: 2,
          nome: "doc_cpf",
          href: "#",
        },
        {
          documento: "Documento: Diploma",
          nome: "doc_diploma",
          tipo: 3,
          href: "#",
        },
        {
          documento: "Documento: Certidão de casamento",
          nome: "doc_certidao_casamento",
          tipo: 4,
          href: "#",
        },
      ],

      data: {
        id: undefined,

        fields: {
          name: true,
          nome_mae: true,
          nome_pai: true,
          cor: true,
          genero: true,
          cpf: true,
          data_nascimento: true,
          contato: true,
          rg: true,
          orgao_emissor: true,
          orgao_emissor_uf: true,
          nacionalidade: true,
          naturalidade_municipio: true,
          naturalidade_uf: true,
          nome_ies: true,
          data_conclusao_ies: true,
          cep: true,
          endereco: true,
          endereco_uf: true,
          municipio: true,
          bairro: true,
          complemento: true,
        },

        files: {
          doc_identidade: true,
          doc_cpf: true,
          doc_diploma: true,
          doc_certidao_casamento: true,
        },

        observacao: "",
      },
    };
  },

  async created() {
    this.data.id = this.$route.params.id;
    this.loadingScreen = true;
    this.loadingUserData = true;

    let erro = false;

    // Busca os dados do aluno
    await UserService.find(this.data.id).then(
      // Sucesso
      (response) => {
        // Usuário encontrado
        this.student = response;

        // Verifica se o campo complemento foi preenchido
        let complemento = "";
        if (response.data.complemento != "null") {
          complemento = response.data.complemento;
        }

        this.fields = [
          {
            campo: "Nome completo",
            nome: "name",
            dado: response.name,
          },
          {
            campo: "Nome completo da mãe",
            nome: "nome_mae",
            dado: response.data.nome_mae,
          },
          {
            campo: "Nome completo do pai",
            nome: "nome_pai",
            dado: response.data.nome_pai,
          },
          {
            campo: "Cor",
            nome: "cor",
            dado: response.data.cor,
          },
          {
            campo: "Gênero",
            nome: "genero",
            dado: response.data.genero,
          },
          {
            campo: "CPF",
            nome: "cpf",
            dado: response.data.cpf,
          },
          {
            campo: "Data de nascimento",
            nome: "data_nascimento",
            dado: this.formatDate(response.data.data_nascimento),
          },
          {
            campo: "Contato",
            nome: "contato",
            dado: response.data.contato,
          },
          {
            campo: "RG",
            nome: "rg",
            dado: response.data.rg,
          },
          {
            campo: "Órgão emissor",
            nome: "orgao_emissor",
            dado: response.data.orgao_emissor,
          },
          {
            campo: "UF do órgão emissor",
            nome: "orgao_emissor_uf",
            dado: response.data.orgao_emissor_uf,
          },
          {
            campo: "Nacionalidade",
            nome: "nacionalidade",
            dado: response.data.nacionalidade,
          },
          {
            campo: "Município de naturalidade",
            nome: "naturalidade_municipio",
            dado: response.data.naturalidade_municipio,
          },
          {
            campo: "UF de naturalidade",
            nome: "naturalidade_uf",
            dado: response.data.naturalidade_uf,
          },
          {
            campo: "IES",
            nome: "nome_ies",
            dado: response.data.nome_ies,
          },
          {
            campo: "Ano de conclusão",
            nome: "data_conclusao_ies",
            dado: response.data.data_conclusao_ies,
          },
          {
            campo: "CEP",
            nome: "cep",
            dado: response.data.cep,
          },
          {
            campo: "Endereço",
            nome: "endereco",
            dado: response.data.endereco,
          },
          {
            campo: "UF",
            nome: "endereco_uf",
            dado: response.data.endereco_uf,
          },
          {
            campo: "Município",
            nome: "municipio",
            dado: response.data.municipio,
          },
          {
            campo: "Bairro",
            nome: "bairro",
            dado: response.data.bairro,
          },
          {
            campo: "Complemento",
            nome: "complemento",
            dado: complemento,
          },
        ];
      },
      // Erro
      () => {
        // Usuário não encontrado
        alert("Ocorreu um erro. Tente novamente mais tarde.");

        erro = true;
      }
    );

    // Verifica os status do usuário
    switch (this.student.status_geral) {
      case 2:
        alert("Este usuário ainda não realizou a submissão do formulário.");
        erro = true;
        break;
      case 5:
        alert(
          "O pedido de revisão já foi enviado. Aguardando a correção do aluno."
        );
        erro = true;
        break;
      case 6:
        alert("Este usuário já foi aprovado.");
        erro = true;
        break;
      case 8:
        alert("Este usuário foi cadastrado no Moodle.");
        erro = true;
        break;
    }

    // Verifica se houve erro na execução de alguma promisse, caso sim, encerra a execução da função
    if (erro) {
      this.loadingScreen = false;
      this.$router.push("/validation");
      return;
    }

    // Verificando o status geral do usuário
    // Trava o aluno para que outro supervisor não possa avaliar
    await Supervisor.lockStatus(this.data.id).then(
      // Sucesso
      () => {
        // Usuário bloqueado
      },
      // Erro
      () => {
        // Não foi possível bloquear o usuário.
        alert(
          "Este usuário já está sendo avaliado. Tente novamente mais tarde."
        );
        this.loadingScreen = false;
        this.$router.push("/validation");

        erro = true;
      }
    );

    // Verifica se houve erro na execução de alguma promisse, caso sim, encerra a execução da função
    if (erro) return;

    // Buscar documentos do aluno
    for (let file in this.files) {
      // Verifica se houve erro na execução de alguma promisse, caso sim, encerra a execução da função
      if (erro) return;

      let object = this.files[file];
      let type = object.tipo;

      await Supervisor.getDocument(this.data.id, type).then(
        // Sucesso
        (response) => {
          // Documento não encontrado
          if ("error" in response) {
            // console.log(response);
          // Documento encontrado
          } else {
            var blob = new Blob([response.data], {
              type: response.headers["content-type"],
            });
            object.href = URL.createObjectURL(blob);
          }
        }
      );
    }

    this.loadingUserData = false;
    this.loadingScreen = false;
  },

  mounted() {
    this.revisionModal = new Modal(document.getElementById("revisionModal"));
    this.reviewSentModal = new Modal(
      document.getElementById("reviewSentModal")
    );
  },

  methods: {
    revision() {
      if (this.checkField.length === 0 && this.checkFile.length === 0) {
        alert(
          "Para solicitar uma revisão, é necessário selecionar pelo menos um dado."
        );
        return;
      }
      this.revisionModal.show();
    },

    openRevisionModal() {
      this.revisionModal.show();
    },

    openReviewSentModal() {
      this.reviewSentModal.show();
    },

    toValidation() {
      this.$router.push("/validation");
    },

    check(fieldName) {
      let address = ["cep", "endereco", "endereco_uf", "municipio", "bairro"];
      switch (fieldName) {
        case "naturalidade_uf":
          this.checkFields(
            fieldName,
            ["naturalidade_municipio"],
            ["naturalidade_municipio"]
          );
          break;

        case "nacionalidade":
          this.checkFields(
            fieldName,
            ["naturalidade_municipio", "naturalidade_uf"],
            ["naturalidade_municipio", "naturalidade_uf"]
          );
          break;

        case "naturalidade_municipio":
          this.checkFields(fieldName, [], ["naturalidade_uf", "nacionalidade"]);
          break;

        case "cep":
        case "endereco":
        case "endereco_uf":
        case "municipio":
        case "bairro":
          if (address.includes(fieldName)) {
            this.checkFields(fieldName, address, address);
          }
          break;
      }
    },

    checkFields(fieldName, arraySelected, arrayDeselected) {
      // Condição para quando seleciona
      if (
        this.checkField.findIndex((field) => field.nome === fieldName) !== -1
      ) {
        if (arraySelected.length === 0) return;
        for (let field of this.fields) {
          if (field.nome === fieldName) continue;
          if (arraySelected.includes(field.nome)) {
            this.checkField.push(field);
          }
        }
      } else {
        // Condição para quando tira a seleção
        if (arrayDeselected.length === 0) return;
        for (let index = 0; index < this.checkField.length; index++) {
          let field = this.checkField[index];

          if (field.nome === fieldName) continue;
          if (arrayDeselected.includes(field.nome)) {
            // Retira o elemento do array
            this.checkField.splice(index, 1);
            index = -1;
          }
        }
      }
    },

    sendValidation() {
      this.loadingScreen = true;

      for (let field in this.checkField) {
        for (let data in this.data.fields) {
          if (this.checkField[field].nome === data) {
            this.data.fields[data] = false;
          }
        }
      }

      for (let file in this.checkFile) {
        for (let data in this.data.files) {
          if (this.checkFile[file].nome === data) {
            this.data.files[data] = false;
          }
        }
      }

      Supervisor.updateStatus(this.data).then(
        // Sucesso
        () => {
          // Status do usuário foi atualizado
          this.loadingScreen = false;
          this.reviewSentModal.show();
        },
        // Erro
        () => {
          // Status do usuário não foi atualizado
          this.loadingScreen = false;
          alert(
            "Não foi possível atualizar o status do usuário. Tente novamente mais tarde."
          );
        }
      );
    },

    formatDate() {
      // Método que formata a data de submissão
      let date = new Date();
      let day = String(date.getDate()).padStart(2, "0");
      let month = String(date.getMonth() + 1).padStart(2, "0");
      let year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },
  },
};
</script>

<style scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

h4.title {
  color: #004a8a;
  font-size: 24px;
  font-weight: bold;
}

td {
  font-weight: bold;
  vertical-align: middle;
  font-size: 18px;
  color: #4f4f4f;
  height: 72px;
}

td:last-child {
  font-weight: normal;
  width: 300px;
}

td:first-child {
  border-radius: 10px 0 0 10px;
}

td:last-child {
  border-radius: 0 10px 10px 0;
  font-size: 16px;
}

td:nth-child(1) {
  text-indent: 2em;
}

tbody {
  background-color: #e0e0e0;
}

.scroll-table {
  width: auto;
  max-width: 100%;
  overflow: auto;
  margin-bottom: 1rem;
}

.table {
  border-spacing: 0 15px;
  border-collapse: separate;
  border-spacing: 0 16px;
  min-width: 740px;
  overflow: auto;
  margin-bottom: 0;
}

.inconsistent-box {
  padding: 15px;
  background-color: #004a8a;
  border-radius: 10px;
  color: white;
  max-width: 200px;
  margin: auto;
}

#label-checkbox {
  display: flex;
  justify-content: center;
}

input[type="checkbox"] {
  vertical-align: middle;
  cursor: pointer;
}

input[type="checkbox"]:before {
  content: "";
  display: block;
  width: 25px;
  height: 25px;
  background-color: #004a8a;
  border: solid 3px white;
}

input[type="checkbox"]:checked:after {
  content: "";
  display: block;
  position: relative;
  left: 6px;
  top: -19px;
  border: solid white;
  width: 13px;
  height: 13px;
  background-color: white;
}

#text {
  margin-left: 1.5em;
  cursor: pointer;
}

td.button {
  max-width: 40px;
}

.view {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #004a8a;
  border: none;
  text-align: center;
  vertical-align: middle;
  margin-right: 2em;
}

.view img {
  display: flex;
  margin: auto;
}

.buttons {
  display: flex;
  margin-top: 3em;
  justify-content: space-between;
  flex-wrap: wrap;
}

.buttons button {
  width: 25em;
  padding: 1em;
  border-radius: 10px;
  border: none;
  color: white;
  background-color: #004a8a;
  font-weight: bold;
  font-size: 18px;
}

button:not([disabled]):hover {
  background-color: #5aad31;
  cursor: pointer;
}

button:disabled {
  background-color: #e0e0e0;
}

button .btn-to-approve {
  background-color: #5aad31;
}

@media (max-width: 576px) {
  button {
    width: 100%;
  }

  .button-container {
    align-items: center;
    flex-direction: column-reverse;
  }

  .btn-to-approve {
    margin-top: 0.5em;
  }

  td:nth-child(1) {
    text-indent: 0;
  }

  td:last-child {
    width: auto;
  }

  #data-table .inconsistent-box {
    width: 200px;
  }
}
</style>
